import { LandingPageSectionApi, CourseGroupListContent } from "api/shop";
import { PaziaBadge } from "components/atoms";
import { SECTION_TYPE_LABELS, SectionType } from "consts/sectionTypes";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import { MdDragIndicator, MdEdit, MdDelete } from "react-icons/md";

interface SectionItemProps {
  section: LandingPageSectionApi;
  onEdit: () => void;
  onDelete: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
}

export const SectionItem = ({ section, onEdit, onDelete, dragHandleProps }: SectionItemProps) => {
  const typeLabel = SECTION_TYPE_LABELS[section.type as SectionType] ?? section.type;
  const content = section.content as CourseGroupListContent | null;
  const sectionName = section.name ?? "Bez nazwy";

  return (
    <div className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-3 transition-colors hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:hover:bg-slate-700">
      {/* Drag Handle */}
      <div {...dragHandleProps} className="cursor-grab text-slate-400 hover:text-slate-600 dark:hover:text-slate-300">
        <MdDragIndicator size={24} />
      </div>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate font-medium text-slate-800 dark:text-slate-100">{sectionName}</span>
          <PaziaBadge color="indigo">{typeLabel}</PaziaBadge>
        </div>
        {content?.description && (
          <p className="mt-1 truncate text-sm text-slate-500 dark:text-slate-400">
            {content.description.replace(/<[^>]*>/g, "").substring(0, 100)}
          </p>
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center gap-1">
        <button
          onClick={onEdit}
          className="rounded p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-indigo-600 dark:hover:bg-slate-600 dark:hover:text-indigo-400"
          title="Edytuj"
        >
          <MdEdit size={20} />
        </button>
        <button
          onClick={onDelete}
          className="rounded p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-red-600 dark:hover:bg-slate-600 dark:hover:text-red-400"
          title="Usuń"
        >
          <MdDelete size={20} />
        </button>
      </div>
    </div>
  );
};
